import { useAuth } from "../../../context/AuthContext"
import BalanceCard from "./BalanceCard"

const MobileDashboardTabs = () => {
	const { totalBalance } = useAuth()
	return <BalanceCard totalBalance={totalBalance} />
}

export default MobileDashboardTabs
